/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sync status details included in appointment sync notifications.  Status values: 0=Pending, 1=InProgress, 2=Success, 3=Failed, 4=Skipped
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface SyncStatus { 
    videoCallStatus: number;
    videoCallError: string;
    zohoCreatorStatus: number;
    zohoCreatorError: string;
    emailStatus: number;
    emailError: string;
    webhookStatus: number;
    webhookError: string;
    cancellationStatus: number;
    cancellationError: string;
    retryCount: number;
    isComplete: boolean;
    hasFailedSteps: boolean;
}
export const SyncStatus_videoCallStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_videoCallError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_zohoCreatorStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_zohoCreatorError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_emailStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_emailError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_webhookStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_webhookError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_cancellationStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_cancellationError_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_retryCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_isComplete_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const SyncStatus_hasFailedSteps_Validators: ValidatorFn[] =
    [  Validators.required, ];


